import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../components/Loading/LoadingPage";

function SignupRedirect() {
  const navigate = useNavigate();
  const { code } = useParams();

  useEffect(() => {
    // Store company code in sessionStorage if present
    if (code) {
      sessionStorage.setItem("company_signup_code", code);
    }

    // Always redirect to loyalty directory
    navigate('/loyalty-directory', { replace: true });
  }, [navigate, code]);

  return <LoadingPage />;
}

export default SignupRedirect;
